import {IDestroy} from "./GameObject";
import * as PIXI from 'pixi.js';
import {Bounds} from "pixi.js/lib/scene/container/bounds/Bounds";

export class GameSprite extends PIXI.Sprite implements IDestroy {

  public needDestroyTexture = false

  override set interactive(value: boolean) {
    super.interactive = value;
    this.interactiveChildren = value;
  }

  override destroy() {
    if (this.destroyed) {
      return;
    }
    this.removeFromParent();
    super.destroy({
      children: true,

      texture: this.needDestroyTexture,
      textureSource: this.needDestroyTexture,
    });
  }

}
